import { render, staticRenderFns } from "./PressKitBio.vue?vue&type=template&id=e0f8552a"
import script from "./PressKitBio.vue?vue&type=script&lang=js"
export * from "./PressKitBio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports